import React from 'react';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import Load from 'components/Load';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import Notfound from 'modules/errorpages/Notfound';
import AppBottomPushDown from 'modules/common/Navbar/PushDown/AppBottomPushDown';
import LoadingDots from 'components/LoadingDots';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import { Translator } from 'Translator';
import LoggedOut from 'modules/user-environment2/components/LoggedOut';
import useCandidateProcess from 'hooks/useCandidateProcess';
import {useUser} from "~/authentication/store";
import StripeLoading from './components/StripeLoading';

const AsyncInvoicePage = Load(() => import(/* webpackChunkName: "host-finance-invoices" */'./containers/InvoicePage'));
const HostOverviewPage = Load(() => import(/* webpackChunkName: "host-finance-overview" */'./containers/OverviewPage'));
const AsyncAddressPage = Load(() => import(/* webpackChunkName: "host-finance-address" */'./containers/AddressPage'));


const SubRoutes = () => {
  const { path } = useRouteMatch();
  const { isHost, isAdmin, loading, isLoggedIn } = useUser();
  const { isCandidate, loading: candidateLoading } = useCandidateProcess();

  if (!loading && !isLoggedIn) {
    return (
      <LoggedOut title={'Login to view this content'} />
    );
  }

  if (loading || candidateLoading) {
    return (
      <LoadingDots />
    );
  }

  if (!isHost && !isAdmin && !isCandidate) {
    return (
      <Redirect to={generatePathnameWithLangCode('/', Translator.getLanguageCode())} />
    );
  }

  return (
    <Switch>
      <Route path={`${path}/loading/`}>
        <StripeLoading />
      </Route>
      <NavigationableLayout
        key="host-finance-invoices"
        path={`${path}/invoices/`}
        hideFooter
        component={AsyncInvoicePage}
        showBottomNavigation
        noNavbar={isCordova()}
        nonFixedNavbar
      />
      <NavigationableLayout
        key="host-finance-invoice-address"
        path={`${path}/invoice-address/`}
        hideFooter
        component={AsyncAddressPage}
        showBottomNavigation
        noNavbar
        nonFixedNavbar
      />
      <NavigationableLayout
        key="host-finance-overview"
        path={`${path}/`}
        hideFooter
        component={HostOverviewPage}
        showBottomNavigation
        noNavbar
        nonFixedNavbar
        exact
      />
      <Route>
        <Notfound />
      </Route>
    </Switch>
  );
};

const routes =
  <Route path={`${basePath}/host/finance`}>
    <>
      <SubRoutes />
      <AppBottomPushDown />
    </>
  </Route>;


export default routes;
